// BTC-1: MTF conviction module
export const environment = {
	production: true,
	quickUnlock: true, // SHADOW: UI szybkiego logowania (PIN/biometria/WebAuthn); backend gate=QUICK_UNLOCK_ENABLED
	webauthn: true, // WebAuthn/passkey UI ON (web e2e)
	API_URL: '/api/v1/',
	FILMS_URL: 'assets/films/', // filmy „Jak to działa” przy alertach
	SOCKET_BINANCE_ENDPOINT: 'wss://stream.binance.com:9443/ws/',
	API_BINANCE_ENDPOINT: 'https://api.binance.com/api/v3/',
	RABBITMQ_ENDPOINT: 'wss://ws.cryptionis.pl:2096/ws',
};
